/*eslint-disable no-new-func */
import { QuotePricing, OldQuotePricing } from 'shared_components';
import $ from 'jquery';
import * as _ from 'lodash';
import StonesStore from "./../../stores/stonesStore";
import ActionTypes from "./../../actionTypes";
import uuid from "uuid";

import Config from "./../../config";

const assign = require('object.assign/polyfill')();

let _currentQuote = -1;
let _quotes = [];
let _jobData = {
  id: 0
};
let _unlockedStones = [];
let _userInfo = null;
let _notes = [];
let _documents = [];
let _selectedNoteIndex = -1;
let _selectedDocumentIndex = -1;
let _stonesViewFirstTimeView = true;
let _stonesViewFirstTimeCustomerLogin = true;
let _defaultHiddenFeatures = null;
let _uploadingQuote = false;
let _shownIntroVideos = {
  stonesView: false
};
let _isDemoProfile = null;
let _sqftcalcLoaded = false;
let _kvStoneId = 0;
let _kvFeatures = [];
let _kvMaterial = 0;

let iframeLayers = {};

/// TODO: Attach Quote Pricing on Load of Stone Data
let _oldQuotePricing = OldQuotePricing();

const parseUrl = () => {
  if (window.location.href.indexOf('kv=1') !== -1) {
    const ar = window.location.href.split('?');

    if (ar.length > 1) {
      _.forEach(ar[1].split('&'), (p) => {
        let pair = p.split('=');
        if (pair.length === 2) {
          const idx = pair[1].indexOf('#');
          if (idx !== -1) {
            pair[1] = pair[1].substring(0, idx);
          }

          switch (pair[0].toLowerCase()) {
            case 'jobid':
              document.kvConfig.jobId = +pair[1];
              document.kvConfig.isBackend = true;
              break;
            case 'email':
              _userInfo = _userInfo || {};
              _userInfo.email = decodeURI(pair[1]);
              break;
            case 'fullname':
              _userInfo = _userInfo || {};
              _userInfo.fullName = decodeURI(pair[1]);
              break;
            case 'zip':
              _userInfo = _userInfo || {};
              _userInfo.zip = decodeURI(pair[1]);
              break;
            case 'phone':
              _userInfo = _userInfo || {};
              _userInfo.phone = decodeURI(pair[1]);
              break;
            case 'password':
              _userInfo = _userInfo || {};
              _userInfo.password = decodeURI(pair[1]);
              break;
            case 'sid':
              _kvStoneId = +pair[1];
              break;
            case 'fids':
              _kvFeatures = [].concat(pair[1].split('.').map(value => +value));
              break;
            case 'material':
              _kvMaterial = +pair[1];
              break;
          }
        }
      });
    }
  }
};

function __calcPriceWithMargin(price, margin) {
  const total = parseFloat(price);
  return (total + (margin * total));
}

/**
 * Checks whether the quantity is valid for a given StoneSupplierStone
 * @param stoneSupplierStone {object}
 * @param quantity {int}
 * @returns {boolean}
 * @private
 */
function __validStoneSupplierStonePrice(stoneSupplierStone, fabricator, quantity) {
  let ret = false;
  let material = quantity;
  let quotePricing = StonesStore.getFabricatorsQuotePricing(fabricator.Id);
  if(quotePricing && quotePricing.hasPricingProfileAssigned(stoneSupplierStone)){
    return true;
  }
  if (stoneSupplierStone.PerQuantity > 1) {
    material = Math.ceil(material / stoneSupplierStone.PerQuantity);
  }
  switch (stoneSupplierStone.ComparisonType) {
    case "lte":
      if (material <= stoneSupplierStone.BaseQuantity) {
        ret = true;
      }
      break;
    case "between":
      if (material >= stoneSupplierStone.BaseQuantity && material <= stoneSupplierStone.MaxQuantity) {
        ret = true;
      }
      break;
    case "gte":
    case "gte+":
      if (material >= stoneSupplierStone.BaseQuantity) {
        ret = true;
      }
      break;
    default:
      ret = true;
  }
  return ret;
}

/**
 * Checkes whether the quantity is valid for a feature
 * @param feature {object}
 * @param quantity {int}
 * @returns {boolean}
 * @private
 */
function __validFeaturePrice(feature, quantity) {
  let ret = false;
  switch (feature.ComparisonType) {
    case "lte":
      if (quantity <= feature.BaseQuantity) {
        ret = true;
      }
      break;
    case "between":
      if (quantity >= feature.BaseQuantity && quantity <= feature.MaxQuantity) {
        ret = true;
      }
      break;
    case "gte":
    case "gte+":
      if (quantity >= feature.BaseQuantity) {
        ret = true;
      }
      break;
    default:
      ret = true;
  }

  return ret;
}

/**
 * Calculates the prices onle for a specific stone
 * @param stone {object}
 * @param quantity {int}
 * @returns {number}
 * @private
 */
function __calculateStonePrice(stone, quantity) {
  if (!stone || !quantity) {
    return 0;
  }
  
  let minPrice = -1;
  let fabricators = [];
  _.each(stone.StoneSupplierStones, function (stoneSupplierStone) {
    let materialPrice = -1;
    let fabIds = stoneSupplierStone.StoneSupplier.FabricatorIds;
    for(var fabId in fabIds) {
      let quotePricing = StonesStore.getFabricatorsQuotePricing(fabIds[fabId]);
      if(quotePricing && quotePricing.hasPricingProfileAssigned(stoneSupplierStone)) {
        var fabPrice = quotePricing.calculatePrice(stoneSupplierStone.PricingPreset_Id, quantity);
        if(materialPrice == -1 || fabPrice < materialPrice) {
          materialPrice = fabPrice;
        }
      }
    }
    if(materialPrice < 0) {
      materialPrice = _oldQuotePricing.calculateStonePrice(stone, quantity);
    }
    if (minPrice === -1 || minPrice > materialPrice) {
      minPrice = materialPrice;
    }
  });
  return minPrice;
/*
  let minPrice = -1;
  _.each(stone.StoneSupplierStones, function (stoneSupplierStone) {
    let price = stoneSupplierStone.Price;
    if (stoneSupplierStone.PricePlus > 0) {
      price = stoneSupplierStone.PricePlus;
    }
    let material = quantity;
    if (stoneSupplierStone.PerQuantity > 1) {
      material = Math.ceil(material / stoneSupplierStone.PerQuantity);
    }
    let materialPrice = price * parseFloat(material);

    let baseQuantity;
    if (stoneSupplierStone.ComparisonType === "gte+") {
      baseQuantity = parseInt(stoneSupplierStone.BaseQuantity) - 1;
      if (material > baseQuantity) {
        let perUnit = parseFloat(stoneSupplierStone.MaxQuantity);
        const margin = stoneSupplierStone.StoneSupplier.Margin;
        perUnit = __calcPriceWithMargin(perUnit, margin);
        materialPrice = baseQuantity * price;
        _.each(stone.StoneSupplierStones, function (stoneSupplierStoneInner) {
          if (stoneSupplierStoneInner.ComparisonType === "between" && material >= stoneSupplierStoneInner.BaseQuantity) {
            materialPrice = stoneSupplierStoneInner.Price;
            for (let n = stoneSupplierStoneInner.MaxQuantity + 1; n <= baseQuantity; n++) {
              materialPrice += price;
            }
          }
        });
        for (let i = baseQuantity + 1; i <= material; i++) {
          materialPrice += perUnit;
        }
      }
    } else if (stoneSupplierStone.ComparisonType === "min") {
      if (parseFloat(material) < stoneSupplierStone.BaseQuantity) {
        materialPrice = price * parseFloat(stoneSupplierStone.BaseQuantity);
      }
    } else if (stoneSupplierStone.ComparisonType === "lte") {
      baseQuantity = parseInt(stoneSupplierStone.BaseQuantity);
      if (material <= baseQuantity) {
        let bFoundOther = false;
        _.each(stone.StoneSupplierStones, function (stoneSupplierStoneInner) {
          if (stoneSupplierStoneInner.ComparisonType === "lte" && material <= stoneSupplierStoneInner.BaseQuantity
            && stoneSupplierStoneInner.BaseQuantity < baseQuantity) {
            bFoundOther = true;
          }
        });
        if (bFoundOther) {
          return;
        }
      }
    } else if (stoneSupplierStone.ComparisonType === "between") {
      materialPrice = stoneSupplierStone.Price;
    }

    if (__validStoneSupplierStonePrice(stoneSupplierStone, material)) {
      if (minPrice === -1 || minPrice > materialPrice) {
        minPrice = materialPrice;
      }
    }
  });

  return minPrice;
  */
}

function __calculateFeaturePricing(scope, materialPrice, fabricator, stoneSupplierStone) {
  let price = 0;
  _.each(fabricator.Features, function (feature, key, list) {
    let featureCost = parseFloat(feature.Cost);

    if (feature.Costplus) {
      featureCost = parseFloat(feature.Costplus);
    }

    if (scope.features[feature.FeatureId]) {
      //console.log('Add price with feature ', scope.features[feature.FeatureId]);
      const scopeAmount = parseFloat(scope.features[feature.FeatureId]);
      let featureTotalPrice = 0;
      if (__validFeaturePrice(feature, scope.features[feature.FeatureId])) {
        if (feature.ComparisonType === "gte+" && feature.ComparisonFor !== "complex") {
          const bQuantity = parseInt(feature.BaseQuantity) - 1;
          let fQuantity = scopeAmount;
          if (feature.ComparisonFor === "material") {
            fQuantity = scope.material;
          }
          const plus = parseFloat(feature.MaxQuantity);
          let cost = bQuantity * featureCost;
          for (let i = bQuantity + 1; i <= fQuantity; i++) {
            cost += plus;
          }
          price += cost;
          featureTotalPrice = cost;
        } else if (feature.ComparisonFor === "complex") {
          const $m = scope.material;
          const $mc = materialPrice / $m;
          const $f = scope.features[feature.FeatureId];
          const $c = featureCost;
          const $fa = scope.features;
          const $fs = fabricator.Features;
          const $p = stoneSupplierStone.PerQuantity;
          const logic = new Function('$m', '$mc', '$f', '$c', '$fa', '$fs', '$p', feature.ComplexLogic);
          featureTotalPrice = logic($m, $mc, $f, $c, $fa, $fs, $p);
          price += featureTotalPrice;
        } else if (feature.ComparisonType === "min" && feature.ComparisonFor !== "complex") {
          const f = scope.features[feature.FeatureId];
          if (f < feature.BaseQuantity) {
            price = featureCost * feature.BaseQuantity;
            featureTotalPrice = price;
          } else {
            featureTotalPrice = parseInt(f) * featureCost;
            price += featureTotalPrice;
          }
        } else {
          featureTotalPrice = (featureCost * scopeAmount);
          price += featureTotalPrice;
        }
      } // if (validFeaturePrice())

      scope.featuresCost[feature.FeatureId] = featureTotalPrice;
    } // scope.features[feature.FeatureId]
  });
  return price;
}
/**
 * Calculates the price for a specific quote
 * @param quote {object}
 * @returns {object}
 * @private
 */
function __calculateQuotePrice(quote) {
  if (!quote) {
    //console.log('No Quotes yet');
    return {
      price: 0,
      fabricator: null,
      stoneSupplierStone: null
    };
  }

  const scope = quote;
  if (!scope.stone) {
    //console.log('No stone selected yet');
    return {
      price: 0,
      fabricator: null,
      stoneSupplierStone: null
    };
  }
  const stone = scope.stone;
  const ss = stone.StoneSupplierStones;
  let minPrice = -1;
  let bestFabricator = null;
  let bestStoneSupplierStone = null;

  const materialPrice = __calculateStonePrice(scope.stone, scope.material);
  quote.materialPrice = materialPrice;
  _.each(stone.StoneSupplierStones, function (stoneSupplierStone) {
    // console.log(stone, stoneSupplierStone);
    _.each(stoneSupplierStone.StoneSupplier.Fabricators, function (fabricator) {
      let price = materialPrice + __calculateFeaturePricing(scope, materialPrice, fabricator, stoneSupplierStone);

      if (__validStoneSupplierStonePrice(stoneSupplierStone, fabricator, scope.material)) {
        if (minPrice === -1 || minPrice > price) {
          minPrice = price;
          bestFabricator = fabricator;
          bestStoneSupplierStone = stoneSupplierStone;
        }
      }
    }) // _.each(stoneSupplierStone.StoneSupplier.Fabricators
  }); // _.each(stone.StoneSupplierStones

  return {
    price: minPrice === -1 ? 0 : minPrice,
    fabricator: bestFabricator,
    stoneSupplierStone: bestStoneSupplierStone
  };
}

function __calculateStonesPrice() {
  if (_currentQuote === -1) {
    return;
  }
  const scope = _quotes[_currentQuote];
  const stones = StonesStore.supportedStones();
  _.each(stones, function (item) {
    const stone = item;
    const prices = [];
    _.each(stone.StoneSupplierStones, function (stoneSupplierStone) {
      let fabIds = stoneSupplierStone.StoneSupplier.FabricatorIds;
      let i;
      let price = stoneSupplierStone.Price;
      if (stoneSupplierStone.PricePlus > 0) {
        price = stoneSupplierStone.PricePlus;
      }
      let material = scope.material;
      for(var fab in fabIds) {
        let quotePricing = StonesStore.getFabricatorsQuotePricing(fabIds[fab]);
        if(quotePricing && quotePricing.hasPricingProfileAssigned(stoneSupplierStone)) {
          let fabObj = _.first(stoneSupplierStone.StoneSupplier.Fabricators.filter(_ => _.Id == fabIds[fab]));
          let materialPrice = quotePricing.calculatePrice(stoneSupplierStone.PricingPreset_Id, material, stoneSupplierStone);
          price = materialPrice + __calculateFeaturePricing(scope, materialPrice, fabObj, stoneSupplierStone);
          if(price) {
            prices.push(~~price);
          }
        }
      }
      if(prices.length == 0) {
        if (stoneSupplierStone.PerQuantity > 1) {
          material = Math.ceil(scope.material / stoneSupplierStone.PerQuantity);
        }

        let materialPrice = price * parseFloat(material);

        let baseQuantity;
        if (stoneSupplierStone.ComparisonType === "gte+") {
          baseQuantity = parseInt(stoneSupplierStone.BaseQuantity) - 1;
          if (material > baseQuantity) {
            let perUnit = parseFloat(stoneSupplierStone.MaxQuantity);
            const margin = stoneSupplierStone.StoneSupplier.Margin;
            perUnit = __calcPriceWithMargin(perUnit, margin);
            materialPrice = baseQuantity * price;
            _.each(stone.StoneSupplierStones, function (stoneSupplierStoneInner, key, list) {
              if (stoneSupplierStoneInner.ComparisonType === "between" && material >= stoneSupplierStoneInner.BaseQuantity) {
                materialPrice = stoneSupplierStoneInner.Price;
                for (let n = stoneSupplierStoneInner.MaxQuantity + 1; n <= baseQuantity; n++) {
                  materialPrice += price;
                }
              }
            });
            for (i = baseQuantity + 1; i <= material; i++) {
              materialPrice += perUnit;
            }
          }
        } else if (stoneSupplierStone.ComparisonType === "min") {
          if (parseFloat(material) < stoneSupplierStone.BaseQuantity) {
            materialPrice = price * parseFloat(stoneSupplierStone.BaseQuantity);
          }
        } else if (stoneSupplierStone.ComparisonType === "lte") {
          baseQuantity = parseInt(stoneSupplierStone.BaseQuantity);
          if (material <= baseQuantity) {
            let bFoundOther = false;
            _.each(stone.StoneSupplierStones, function (stoneSupplierStoneInner, key, list) {
              if (stoneSupplierStoneInner.ComparisonType === "lte" && material <= stoneSupplierStoneInner.BaseQuantity
                && stoneSupplierStoneInner.BaseQuantity < baseQuantity) {
                bFoundOther = true;
              }
            });
            if (bFoundOther) {
              return;
            }
          }
        } else if (stoneSupplierStone.ComparisonType === "between") {
          materialPrice = stoneSupplierStone.Price;
        }

        _.each(stoneSupplierStone.StoneSupplier.Fabricators, function (fabricator) {
          price = materialPrice + __calculateFeaturePricing(scope, materialPrice, fabricator, stoneSupplierStone);
          
          if (__validStoneSupplierStonePrice(stoneSupplierStone, fabricator, scope.material)) {
            prices.push(~~price);
          }
        });
      }
    });


    prices.sort(function (a, b) {
      return a - b;
    });
    stone.priceRange = "";

    if (prices.length > 0) {
      stone.priceRange = "$" + prices[0];
    }

    if (prices.length > 1) {
      stone.priceRange += " - $" + prices[prices.length - 1];
    }

    stone.prices = prices;
  });
}

const __rgFlagWithValue = /^([a-z])([0-9])$/i;
function _injectHiddenFeaturesIntoQuote(quote) {

  if (!_defaultHiddenFeatures) {
    const headFeatures = StonesStore.headFeatures();

    if (_.size(headFeatures)) {
      _defaultHiddenFeatures = _defaultHiddenFeatures || [];
    }
    _.each(headFeatures, function (hf) {
      _.each((hf.flags || []), function (flag) {
        const match = __rgFlagWithValue.exec(flag);
        if (match) {
          const quantity = parseInt(match[2]);
          if (quantity > 0) {
            _defaultHiddenFeatures.push({quantity: quantity, feature: hf});
          }
        }
      });
    });
  }

  _.each(_defaultHiddenFeatures, function (objF) {
    quote.features[objF.feature.id] = objF.quantity;
  });
}

function _handleDataReady(e, data) {
  _.each(_quotes || [], function (quote) {
    _injectHiddenFeaturesIntoQuote(quote);
  });

  _notes = [];
  _.each(data.newQuoteData.notes, function (note) {
    _notes.push({
      uid: uuid.v4(),
      title: note.title,
      text: note.text,
      changed: false,
      isNew: false,
      noteId: note.noteId
    });
  });
  _selectedNoteIndex = _.size(_notes) ? 0 : -1;

  _documents = [];
  _.each(data.newQuoteData.documents, function (doc) {
    _documents.push({
      name: doc.name,
      uid: uuid.v4(),
      text: doc.text,
      created: new Date(doc.created),
      uploaded: true,
      fullUrl: doc.fullUrl,
      documentId: doc.documentId
    });
  });
  _selectedDocumentIndex = _.size(_documents) ? 0 : -1;
}

function _handleQuoteSaved() {
  _uploadingQuote = false;
}

$(document).on(ActionTypes.SERVER_DATA_READY, _handleDataReady);
$(document).on(ActionTypes.QUOTE_SAVED, _handleQuoteSaved);

parseUrl();

module.exports = {
  shownIntroVideos: function (name) {
    return _shownIntroVideos[name];
  },
  setShownIntroVideos: function (name, shown) {
    _shownIntroVideos[name] = shown;
  },
  uploadingQuote: function () {
    return _uploadingQuote;
  },

  setUploadingQuote: function (value) {
    _uploadingQuote = value;
  },

  /***
   * 2 Flags to indicate if we are first time on the stones view or first time customer login,
   * is needed to show a glowing green thing on the stones
   */
  stonesViewFirstTimeView: function (value) {
    if (value !== undefined) {
      _stonesViewFirstTimeView = value;
    } else {
      return _stonesViewFirstTimeView;
    }
  },

  stonesViewFirstTimeCustomerLogin: function (value) {
    if (value !== undefined) {
      _stonesViewFirstTimeCustomerLogin = value;
    } else {
      return _stonesViewFirstTimeCustomerLogin;
    }
  },

  /***
   After customer submitted the quote we are not allowing him to navigate away from summaryView
   */
  quoteSubmitted: false,

  /**
   * Is filled after the customer logins
   */
  userInfo: function () {
    return _userInfo;
  },

  /**
   * Set user info
   * @param userInfo {object}
   */
  setUserInfo: function (userInfo) {
    _userInfo = userInfo;
  },

  /**
   * Keeps the information about the sales person, cannot be used when customers logins or registers
   * Used when saving the actual quote, (legacy stuff)
   */
  salesPerson: {
    name: '',
    email: ''
  },

  /***
   * After first time the quote is saved we will get the JobID
   */
  jobId: document.kvConfig.jobId,

  /**
   * Used in offline kiosk to pre-populate register and login data for the DEMO profile.
   */
  isDemoProfile: function () {
    if (_isDemoProfile !== null) {
      return _isDemoProfile;
    }

    const subDomain = document.kvConfig.subdomain || document.kvConfig.subDomain;
    _isDemoProfile = subDomain &&
      _.some(['demo', 'cosentino'], (d) => subDomain.toLowerCase() === d);
    return _isDemoProfile;
  },

  /**
   * When loaded from backend it will have the quoteId of the quote that needs to be edited
   */
  quoteId: document.kvConfig.quoteId,

  /**
   * Gets whether the application was started from back-end.
   */
  isBackend: document.kvConfig.isBackend,

  /**
   * This is set by the DashBoard, and indicates whether the currently logged user
   * can Save the quote. Usually  the regular clients are not allowed to do so
   */
  canSaveQuote: document.kvConfig.canSaveQuote === null ? true : document.kvConfig.canSaveQuote,

  /**
   * This is set by the offline kiosk, stating the application runs in offline mode
   */
  isInKioskMode: document.kvConfig.kioskMode === true,

  /**
   * Indicates whether this user was a new one or an existing. Used to send back to back-end when saving the quote
   */
  isNewUser: false,

  /**
   * This will be set to true when the quoting tool is opened from server
   */
  serverSide: document.kvConfig.isBackend || false,
  /**
   * Returns current quote data
   * @returns {*}
   */
  quote: function () {
    if (_quotes.length === 0) {
      this.addQuote();
      _sqftcalcLoaded = false;
      $(document).trigger(ActionTypes.QUOTE_DATA_CHANGED, {});
    }

    return _quotes[_currentQuote];
  },

  /**
   * Returns all quotes
   * @returns {Array}
   */
  quotes: function () {
    return _quotes;
  },

  quotesCount: function () {
    return _quotes.length;
  },

  /**
   * Adds a new quote to the project scope
   */
  addQuote: function (raiseChangedEvent) {
    let material = 1;
    let features = {};
    let featuresToDisplay = {};
    let featuresCost = {};

    if (_quotes.length > 0) {
      const lastQuote = _.last(_quotes);
      material = lastQuote.material;
      features = _.clone(lastQuote.features);
      featuresToDisplay = _.clone(lastQuote.features);
      featuresCost = _.clone(lastQuote.featuresCost);
    }

    _quotes.push({
      material: material,
      features: {}, // feature ID -> Quantity
      featuresToDisplay: {}, // feature ID -> Quantity
      featuresCost: {}, // featureID -> Cost
      stone: null, // dbStone
      totalPrice: 0,
      materialPrice: 0,
      uid: new Date().getTime(),
      quoteId: 0,
      selectedNoteIndex: 0,
      selectedDocumentIndex: 0,
      sFtCalcDataJson: null
    });

    _currentQuote = _quotes.length - 1;
    _sqftcalcLoaded = false;

    const lastQuote = _quotes[_currentQuote];
    _injectHiddenFeaturesIntoQuote(lastQuote);
    _.each(features, (quantity, featureID) => {
      lastQuote.features[featureID] = quantity;
    });
    _.each(featuresToDisplay, (quantity, featureID) => {
      lastQuote.featuresToDisplay[featureID] = quantity;
    });
    _.each(featuresCost, (cost, featureID) => {
      lastQuote.featuresCost[featureID] = cost;
    });

    this.recalculateAll(raiseChangedEvent);
    //Necessary to fix issue when adding a new countertop and clicking View in Visualizer without selecting a stone
    this.setStone(null);
    return lastQuote;
  },

  setStone: function (stone) {
    const quote = this.quote();
    quote.stone = stone;
    this.recalculateAll(true);
    StonesStore.setUnsavedChanges();
  },

  setFeatures: function (nextFeatures) {
    const quote = this.quote();
    quote.features = nextFeatures;
    this.recalculateAll(true);
    StonesStore.setUnsavedChanges();
  },

  setFeaturesToDisplay: function (nextFeatures) { //remove this commit and use setFeatures when we will need to change features in right column list
    _quotes[_currentQuote].featuresToDisplay = nextFeatures;
    this.recalculateAll(true);  // this is needed to trigger QUOTE_DATA_CHANGED
  },

  reset: function () {
    if (_currentQuote === -1) {
      return;
    }

    const quote = this.quote();
    quote.features = {};
    quote.featuresCost = {};
    quote.featuresToDisplay = [];
    this.recalculateAll(true);
  },

    /**
     * Recalculates the prices for current quote
     * @param raiseChangedEvent {boolean}
     * @param calculateAllQuotes {boolean} - Forces to recalculate all quotes
     * @param allStones {boolean}
     */
  recalculateAll: function (raiseChangedEvent = false, calculateAllQuotes = false, allStones = true) {
    const quote = this.quote();
    if(allStones)
      __calculateStonesPrice();
    const bestPrice = __calculateQuotePrice(quote);
    quote.totalPrice = bestPrice.price;
    quote.stoneSupplierStone = bestPrice.stoneSupplierStone;

    this.saveUnlockedStones();

    if (calculateAllQuotes) {
      _.each(_quotes, q => {
        if (q.uid !== quote.uid) {
          const newBestPrice = __calculateQuotePrice(q);
          q.totalPrice = newBestPrice.price;
          q.stoneSupplierStone = newBestPrice.stoneSupplierStone;
        }
      });
    }

    if (raiseChangedEvent) {
      $(document).trigger(ActionTypes.QUOTE_DATA_CHANGED, {});
    }
  },


  job: function () {
    return _jobData;
  },

  resetJob: function () {
    _userInfo = null;
    _quotes = [];
    _notes = [];
    _documents = [];
    _stonesViewFirstTimeCustomerLogin = true;
    _stonesViewFirstTimeView = true;
    if (Config.kioskStandAlone) {
      _jobData = {id: 0};
    }
    document.kvConfig.stepFinished = 0;
    this.jobId = null;
    _sqftcalcLoaded = false;
    this.quoteSubmitted = false;
    this.addQuote(true);
  },

  /**
   *
   * @param featuresIdsFromGroup [featureId, ...]
   * @param features {object} featureId -> quantity
   * @param previousCalcData {object} {edges, sinks, etc} // data came from SQFT
   */
  updateFeaturesQuantities: function (featuresIdsFromGroup, features, previousCalcData = null, quoteEdges) {
    const quote = this.quote();
    // remove all from group
    _.each(featuresIdsFromGroup, function (id) {
      delete quote.features[id];
    });

    if (previousCalcData) {
      previousCalcData.edges && previousCalcData.edges.length && previousCalcData.edges.forEach(function (edge) {
        if (quote.features[edge.id] && !_.includes(featuresIdsFromGroup, edge.id)) { // if it exists on this moment
          delete quote.features[edge.id];
        }
      });
      previousCalcData.radiuses && previousCalcData.radiuses.length && previousCalcData.radiuses.forEach(function (radiusID) {
        if (quote.features[radiusID] && !_.includes(featuresIdsFromGroup, radiusID)) { // if it exists on this moment
          delete quote.features[radiusID];
        }
      });
    }

    _.each(features, function (quantity, featureId) {
      if (quantity) {
        quote.features[featureId] = quantity;
      }
    });

    if (quoteEdges) {
      quote.quoteEdges = quoteEdges;
    }

    this.recalculateAll(true);
  },

  /**
   * returns the IDs of the currently selected features
   * they shall be grouped by GroupName, but maybe later
   */
  selectedFeatures: function () {
    return _.keys(this.quote().features).map(function (k) {
      return parseInt(k);
    });
  },

  /**
   * Removes a feature from current quote
   * @param featureId
   */
  removeFeature: function (featureId) {
    delete this.quote().features[featureId];
    this.recalculateAll(true);
  },

  updateFeatureQuantity: function (featureId, quantity) {
    const q = this.quote();
    const f = q.features;
    if (f[featureId] === undefined) {
      throw "Trying to change the quantity for an non-existent feature: " + featureId;
    }

    f[featureId] = quantity;
    if (quantity === 0) {
      q.featuresCost[featureId] = 0;
    }
    this.recalculateAll(true);
  },

  updateMaterialQuantity: function (material) {
    const q = this.quote();
    q.material = material;
    if(q.material != "" && q.material == 0) {
      q.material = 1;
    }
    this.recalculateAll(true);
  },

  updateQuoteMaterialQuantity: function(material) {
    const q = this.quote();
    q.material = material;
    this.recalculateAll(true, false, false);
  },

  /***
   * Sets the current quote for project
   * @param quoteUID
   */
  setCurrentQuote: function (quoteUID) {
    const quoteIndex = _.findIndex(_quotes, {uid: quoteUID});
    if (quoteIndex === -1) {
      throw 'Received a wrong Quote UID to set: ' + quoteUID;
    }

    _currentQuote = quoteIndex;
    this.recalculateAll(true);
  },

  deleteQuote: function (uid) {
    if (_quotes.length === 1) {
      _quotes = [];
      this.addQuote();
      _sqftcalcLoaded = false;
      this.recalculateAll(true);
      return;
    }

    const idx = _.indexOf(_quotes, {uid: uid});
    const changeSelection = idx <= _currentQuote;
    _.remove(_quotes, {uid: uid});
    if (changeSelection) {
      _currentQuote = Math.max(0, --_currentQuote);
    }

    $(document).trigger(ActionTypes.QUOTE_DATA_CHANGED, {});
    $(document).trigger(ActionTypes.QUOTE_DELETED, {});
  },

  saveUnlockedStones: function () {
    _unlockedStones = _.take(_.orderBy(_.filter(StonesStore.supportedStones(), function (s) {
      return s.Name !== 'No Stone Selected';
    }), function (s) {
      return s.prices[0];
    }, ['asc']), 3).map(function (s) {
      return s.Id;
    });
  },

  unlockedStones: function () {
    return _unlockedStones;
  },

  loadJobData: function (data) {
    if (!data) {
      return;
    }
    _quotes = [];
    let selectedIndex = 0;
    _.each(data.quotes, (q) => {
      const dbStone = StonesStore.stoneById(q.stone.id);
      const quote = {
        material: q.material,
        features: {}, // feature ID -> Quantity
        featuresCost: {}, // featureID -> Cost
        stone: dbStone, // dbStone
        totalPrice: 0,
        materialPrice: q.stoneCost,
        uid: _.uniqueId(),
        quoteId: q.id,
        stoneSupplierStone: _.find(dbStone.StoneSupplierStones, {Id: q.stoneSupplierStone.Id}),
        sFtCalcDataJson: q.sFtCalcDataJson
      };
      _.each(q.features, (f) => {
        quote.features[f.featureId] = f.quantity;
      });

      if (q.id === document.kvConfig.quoteId) {
        selectedIndex = _quotes.length;
      }

      _quotes.push(quote);
    });

    _currentQuote = selectedIndex;
    _userInfo = {};
    assign(_userInfo, data.userInfo);
  },

  /**
   * NOTES
   */

  notes: function () {
    return _notes;
  },
  /**
   * Gets the current note from the current quote
   */
  currentNote: function () {
    if (_notes.length === 0) {
      return null;
    }

    return _notes[_selectedNoteIndex];
  },

  addNote: function (triggerEvent) {
    triggerEvent = triggerEvent === undefined ? true : triggerEvent;
    const newNote = {
      uid: uuid.v4(),
      title: new Date(),
      text: '',
      changed: true,
      isNew: true
    };
    _notes.unshift(newNote);

    _selectedNoteIndex = 0;
    if (triggerEvent) {
      $(document).trigger(ActionTypes.CURRENT_NOTE_CHANGED, {});
    }

    return newNote;
  },

  cancelNoteEditing: function () {
    const note = this.currentNote();
    if (note.isNew) {
      _.remove(_notes, {uid: note.uid});
      if (_selectedNoteIndex > 0) {
        _selectedNoteIndex--;
      }
    } else {
      note.changed = false;
    }

    $(document).trigger(ActionTypes.CURRENT_NOTE_CHANGED, {});
  },

  saveNote: function (text) {
    const note = this.currentNote();
    if (note.isNew && !text.trim().length) {
      _.remove(_notes, {uid: note.uid});
      _selectedNoteIndex = 0;
    } else {
      note.text = text;
      note.isNew = false;
      note.changed = false;
    }

    $(document).trigger(ActionTypes.CURRENT_NOTE_CHANGED, {});
  },

  markNoteChanged: function () {
    let note = this.currentNote();
    if (!note) {
      note = this.addNote(false);
    }

    note.changed = true;

    $(document).trigger(ActionTypes.CURRENT_NOTE_CHANGED, {});
  },

  selectNote: function (note) {
    _selectedNoteIndex = _.findIndex(_notes, {uid: note.uid});
    $(document).trigger(ActionTypes.CURRENT_NOTE_CHANGED, {});
  },

  deleteNote: function (note) {
    _.remove(_notes, {uid: note.uid});
    if (_selectedNoteIndex > 0) {
      _selectedNoteIndex--;
    }
    $(document).trigger(ActionTypes.CURRENT_NOTE_CHANGED, {});
  },

  /**
   * UPLOADS, DOCUMENTS
   */
  documents: function () {
    return _documents;
  },

  currentDocument: function () {
    if (_documents.length === 0) {
      return null;
    }

    return _documents[_selectedDocumentIndex];
  },

  selectDocument: function (doc) {
    _selectedDocumentIndex = _.findIndex(_documents, {uid: doc.uid});
    $(document).trigger(ActionTypes.DOCUMENTS_CHANGED, {});
  },

  deleteDocument: function (doc) {
    _.remove(_documents, {uid: doc.uid});
    if (_selectedDocumentIndex > 0) {
      _selectedDocumentIndex--;
    }
    $(document).trigger(ActionTypes.DOCUMENTS_CHANGED, {});
  },

  addDocument: function (file, description) {
    _documents.unshift({
      name: file.name,
      uid: uuid.v4(),
      text: description,
      created: new Date(),
      uploaded: false,
      file: file // the blob file
    });
    _selectedDocumentIndex = 0;
    $(document).trigger(ActionTypes.DOCUMENTS_CHANGED, {});
  },

  saveDocument: function (text) {
    const d = this.currentDocument();
    d.text = text;
    d.changed = false;

    $(document).trigger(ActionTypes.DOCUMENTS_CHANGED, {});
  },

  markDocumentChanged: function () {
    const doc = this.currentDocument();
    doc.changed = true;

    $(document).trigger(ActionTypes.DOCUMENTS_CHANGED, {});
  },

  isSqFtCalcLoaded: function () {
    return _sqftcalcLoaded;
  },
  setSqFtCalcLoaded: function (value = true) {
    _sqftcalcLoaded = value;
  },

  getIframeState: function() {
    return _quotes[_currentQuote].iframeState;
  }
};


document.setIframeState = function(state) {
  // console.log('KV -> QT state', state);
  _quotes[_currentQuote].iframeState = state;
};


// WEBPACK FOOTER //
// ./src/components/projectScope/projectScope.js